import { ref, type Ref } from 'vue';

import { createSingleton } from '@deepidoo/deesplay-shared/utils';

import { type OAuthResponse } from '../clients';

export const useSession = createSingleton((): {
	isAuthenticated: Ref<boolean>;
	isRefreshable: Ref<boolean>;
	accessToken: Ref<string | null>;
	refreshToken: Ref<string | null>;
	setSession: (loginResponse: OAuthResponse) => void;
	clearSession: () => void;
	checkSession: () => void;
} => {
	const isAuthenticated = ref(false);
	const isRefreshable = ref(false);
	const accessToken = ref<string | null>(localStorage.getItem('accessToken'));
	const refreshToken = ref<string | null>(localStorage.getItem('refreshToken'));

	const setSession = (loginResponse: OAuthResponse): void => {
		localStorage.setItem('accessToken', loginResponse.access_token);
		localStorage.setItem('refreshToken', loginResponse.refresh_token);
		localStorage.setItem('tokenExpiresIn', String(loginResponse.expires_in));
		localStorage.setItem('tokenCreatedAt', String(loginResponse.created_at));
		isAuthenticated.value = true;
		isRefreshable.value = true;
		accessToken.value = loginResponse.access_token;
		refreshToken.value = loginResponse.refresh_token;
	};

	const clearSession = (): void => {
		localStorage.removeItem('accessToken');
		localStorage.removeItem('refreshToken');
		localStorage.removeItem('tokenExpiresIn');
		localStorage.removeItem('tokenCreatedAt');
		isAuthenticated.value = false;
		isRefreshable.value = false;
		accessToken.value = null;
		refreshToken.value = null;
	};

	const checkSession = (): void => {
		const tokenExpiresIn = localStorage.getItem('tokenExpiresIn');
		const tokenCreatedAt = localStorage.getItem('tokenCreatedAt');
		isAuthenticated.value = accessToken.value != null && refreshToken.value != null && (Date.now() < ((Number(tokenCreatedAt) + Number(tokenExpiresIn)) * 1000));
		isRefreshable.value = accessToken.value != null && refreshToken.value != null;
	};

	return {
		isAuthenticated,
		isRefreshable,
		accessToken,
		refreshToken,
		setSession,
		clearSession,
		checkSession
	};
});